import { Component, h, Prop } from '@stencil/core';
import { CssClassMap, BadgeVariant, BadgeType, BadgePosition, BadgeSize } from './jui-badge.model';

@Component({
  tag: 'jui-badge',
  styleUrl: 'jui-badge.scss',
  shadow: true
})
export class JuiBadge {
  /**
   * Badge color: primary | secondary | success | info | warning | danger | light | dark
   */
  @Prop() color: BadgeVariant = BadgeVariant.primary;

  /**
   * Badge type: count | label | marker
   */
  @Prop() type: BadgeType = BadgeType.count;

  /**
   * Badge size: sm | md
   * Defaults to md
   */
  @Prop() size: BadgeSize = BadgeSize.md;

  /**
   * Badge position: topRight | topLeft | bottomRight | bottomLeft
   */
  @Prop() position: BadgePosition = BadgePosition.topRight;

  /**
   * Badge pulse - pulsing animation (runs continuously)
   */
  @Prop() pulse = false;

  /**
   * Badge announce - announce animation (runs once)
   */
  @Prop() announce = false;

  /**
   * Badge outline - 1px border outline
   */
  @Prop() outlined = false;

  private getCssClassMap(): CssClassMap {
    return {
      badge: true,
      'badge--pulsing': this.pulse,
      'badge--announce': this.announce,
      'badge--outlined': this.outlined,
      [`badge--${this.color}`]: true,
      [`badge--${this.position}`]: true,
      [`badge--${this.position}-${this.size}`]: true,
      [`badge--${this.type}`]: true,
      [`badge--${this.type}-${this.size}`]: true
    };
  }

  render() {
    const hasContent: boolean = ['count', 'label'].includes(this.type);
    const classMap = this.getCssClassMap();
    return (
      <div class={classMap}>
        {hasContent && (
          <div class={'badge__content'}>
            <slot></slot>
          </div>
        )}
      </div>
    );
  }
}
